import {FC, useCallback, useState} from 'react';
import {useLocation} from 'wouter';

import {Input} from '@shared_web/components/core/input';
import {hideModal} from '@shared_web/components/core/modal';
import {showSuccess, showAlert} from '@shared_web/components/core/notifications';
import {notifyError} from '@shared_web/lib/notification';

import {GenericModalForm} from '@mavismart_frontend/components/generic_modal_form';
import {translate} from '@mavismart_frontend/components/translate';
import {apiCall} from '@mavismart_frontend/lib/api';
import {INPUT_THEME, INPUT_THEME_ERROR} from '@mavismart_frontend/lib/constants';
import {getUserLanguage, useAccount} from '@mavismart_frontend/stores/account_store';
import {addGroup} from '@mavismart_frontend/stores/groups_store';

export const CustomGroupForm: FC = () => {
  const [, navigate] = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [titleCustomGroup, setTitleCustomGroup] = useState<string | undefined>(undefined);
  const [hasError, setHasError] = useState(false);
  const account = useAccount();

  const handleSubmit = useCallback(async () => {
    if (titleCustomGroup) {
      setHasError(false);
      try {
        setIsLoading(true);
        const newGroup = await apiCall('POST /create-custom-group', {name: titleCustomGroup});
        addGroup(newGroup);
        navigate(`/groups/${newGroup.group.id}`);
        showSuccess(translate('custom_group_created', getUserLanguage(account)));
        hideModal();
        setTitleCustomGroup(undefined);
      } catch (err) {
        notifyError(err);
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    } else {
      setHasError(true);
      showAlert(translate('all_fields_required', getUserLanguage(account)));
    }
  }, [account, titleCustomGroup, navigate]);

  return (
    <GenericModalForm
      onSubmit={handleSubmit}
      loading={isLoading}
      childrenInput={
        <Input
          width={309}
          type="text"
          autoComplete="off"
          value={titleCustomGroup}
          syncState={setTitleCustomGroup}
          placeholder={translate('custom_group_name', getUserLanguage(account))}
          themeOverrides={
            hasError
              ? {
                  input: {
                    ...INPUT_THEME_ERROR,
                  },
                }
              : {input: {...INPUT_THEME}}
          }
        />
      }
    />
  );
};

CustomGroupForm.displayName = 'CustomGroupForm';
